import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ThrashIcon = createIcon({
  displayName: 'ThrashIcon',
  path: (
    <path
      d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v10ZM9 9h6c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1H9c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1Zm6.5-5-.71-.71c-.18-.18-.44-.29-.7-.29H9.91c-.26 0-.52.11-.7.29L8.5 4H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1h-2.5Z'
      fill='currentColor'
    />
  ),
  defaultProps: defaultProps
})
